import authAxios from "../authAxios";
import unauthAxios from "../axios";

export const upsertNotificationAuthRequired = (
  trip_id,
  project_id,
  notify,
  soldOut = false,
  waitlist,
  saveProject = false
) =>
  authAxios.post("/v1/notifications/upsertNotificationAuthRequired", {
    trip_id: trip_id,
    project_id: project_id,
    notify: notify,
    soldOut: soldOut,
    waitlist,
    saveProject
  });

export const upsertWebinarNoticationAuthRequired = (webinar_id, project_id, invite_link) =>
  authAxios.post("/v1/notifications/upsertWebinarNoticationAuthRequired", {
    webinar_id,
    project_id,
    invite_link,
  });

export const upsertNotificationNoAuth = (trip_id, project_id, user_id) => {
  return unauthAxios.post("/v1/notifications/upsertNotificationNoAuth", {
    trip_id: trip_id,
    project_id: project_id,
    user_id: user_id,
  });
}


export const sendGenericMessage = async (message) =>
  await authAxios.post("/v1/notifications/sendGenericMessage", {
    message: message,
  });

export const getOptionWaitlist = (tripId) =>
  authAxios.get("/v1/notifications/optionWaitlist", { params: { trip_id: tripId } });

export const joinOptionWaitlist = (tripId, optionType, optionId) =>
  authAxios.post("/v1/notifications/optionWaitlist", {
    trip_id: tripId,
    option_type: optionType,
    option_id: optionId,
  });
